// src/pages/evenements/naissances/NouvelleNaissance.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../../layouts/Header';
import Footer from '../../../layouts/Footer';
import { COLORS } from '../../../constants/colors';

// ===== STYLES (identiques à AjouterTemple) =====
const styles = `
  .dashboard-styled {
    background: #f4f6f9;
    min-height: 100vh;
  }

  .header-modern {
    background: white;
    padding: 1.2rem 1.8rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border-left: 4px solid ${COLORS.secondary};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    background: ${COLORS.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-size: 1.4rem;
  }

  .gradient-text {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
  }

  .badge-modern {
    background: #f1f4f9;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .badge-modern i {
    color: ${COLORS.secondary};
  }

  .btn-modern-outline {
    border: 1px solid #d1d5db;
    background: white;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-modern-outline:hover {
    border-color: ${COLORS.secondary};
    color: ${COLORS.secondary};
    background: #fafafa;
  }

  .btn-modern-primary {
    background: ${COLORS.primary};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-primary:hover {
    background: ${COLORS.primaryDark};
    box-shadow: 0 4px 10px rgba(41,90,167,0.3);
  }

  .btn-modern-success {
    background: ${COLORS.success};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-success:hover {
    background: #059669;
    box-shadow: 0 4px 10px rgba(16,185,129,0.3);
  }

  .card-modern {
    border: none;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    border-top: 3px solid transparent;
    transition: box-shadow 0.2s;
  }
  .card-modern:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
  .card-modern.border-primary {
    border-top-color: ${COLORS.primary};
  }

  .card-header-modern {
    background: transparent;
    border-bottom: 1px solid #e9edf2;
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .card-header-modern i {
    color: ${COLORS.secondary};
  }

  .card-body-modern {
    padding: 1.5rem;
  }

  .form-label-modern {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.2rem;
  }
  .form-label-modern .required {
    color: ${COLORS.danger};
    margin-left: 2px;
  }

  .form-control-modern, .form-select-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }
  .form-control-modern:focus, .form-select-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41,90,167,0.08);
  }

  .toast-notification {
    padding: 0.8rem 1rem;
    border: none;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 1.5rem;
    animation: slideDown 0.3s ease-out;
    border-radius: 4px;
  }
  .toast-notification-success {
    background: #f0fdf4;
    border-left: 3px solid ${COLORS.success};
  }
  .toast-notification-error {
    background: #fef2f2;
    border-left: 3px solid ${COLORS.danger};
  }
  .toast-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }
  .toast-icon-success {
    background: rgba(16,185,129,0.15);
    color: ${COLORS.success};
  }
  .toast-icon-error {
    background: rgba(239,68,68,0.15);
    color: ${COLORS.danger};
  }
  .toast-content {
    flex: 1;
  }
  .toast-title {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1px;
  }
  .toast-message {
    font-size: 0.75rem;
    color: #64748b;
    margin: 0;
  }
  .toast-close {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    font-size: 1rem;
  }

  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @media (max-width: 768px) {
    .header-modern {
      flex-direction: column;
      align-items: stretch;
      gap: 0.8rem;
      padding: 1rem;
    }
    .header-left {
      flex-wrap: wrap;
    }
    .card-body-modern {
      padding: 1rem;
    }
  }
`;

export default function NouvelleNaissance() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [eglises, setEglises] = useState([]);

  const [formData, setFormData] = useState({
    parent1: '',
    parent2: '',
    date_nais: new Date().toISOString().split('T')[0],
    lieu: '',
    genre: 'Garçon',
    matri_eglise: ''
  });

  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const userStr = localStorage.getItem('user');
        if (!userStr) {
          navigate('/pages/signin2');
          return;
        }

        const user = JSON.parse(userStr);
        const userId = user.id || user.id_utilisateur;

        const eglisesRes = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}&type=siege&limit=1000`);
        const eglisesData = await eglisesRes.json();
        if (eglisesData.success) {
          setEglises(eglisesData.eglises || []);
        }

        if (id) {
          const naissanceRes = await fetch(`https://josephsbusiness.com/api/naissances.php?user_id=${userId}&id=${id}`);
          const naissanceData = await naissanceRes.json();
          if (naissanceData.success && naissanceData.naissance) {
            const naissance = naissanceData.naissance;
            setFormData({
              parent1: naissance.parent1,
              parent2: naissance.parent2,
              date_nais: naissance.date_nais,
              lieu: naissance.lieu || '',
              genre: naissance.genre,
              matri_eglise: naissance.matri_eglise
            });
          }
        }
      } catch (err) {
        setError('Erreur de chargement: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, navigate]);

  const validateForm = () => {
    const errors = {};
    if (!formData.parent1) errors.parent1 = "Le nom du père est requis";
    if (!formData.parent2) errors.parent2 = "Le nom de la mère est requis";
    if (!formData.date_nais) errors.date_nais = "La date de naissance est requise";
    if (!formData.genre) errors.genre = "Le genre est requis";
    if (!formData.matri_eglise) errors.matri_eglise = "L'église est requise";
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setSaving(true);
    setError(null);

    try {
      const userStr = localStorage.getItem('user');
      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const date = new Date();
      const random = Math.floor(Math.random() * 10000);
      const matricule = `NAI${date.getFullYear()}${(date.getMonth()+1).toString().padStart(2,'0')}${date.getDate().toString().padStart(2,'0')}${random}`;

      const url = `https://josephsbusiness.com/api/naissances.php?user_id=${userId}`;
      const method = id ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          id: id,
          matricule: matricule
        })
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/evenements/naissances?reload=1');
        }, 2000);
      } else {
        setError(result.message || 'Erreur lors de l\'enregistrement');
      }
    } catch (err) {
      setError('Erreur: ' + err.message);
    } finally {
      setSaving(false);
    }
  };

  // ===== Écran de chargement =====
  if (loading) {
    return (
      <>
        <Header />
        <div className="main main-app p-3 p-lg-4 dashboard-styled">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
            <div className="text-center">
              <Spinner animation="border" variant="primary" style={{ width: '4rem', height: '4rem', color: COLORS.primary }} />
              <h5 className="fw-bold mt-3" style={{ color: COLORS.primaryDark }}>
                Chargement de la naissance
              </h5>
              <p className="text-muted small">Préparation du formulaire...</p>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  // ===== Rendu principal =====
  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main main-app p-3 p-lg-4 dashboard-styled">
        <div className="container-fluid px-0">

          {/* ===== EN‑TÊTE MODERNE ===== */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper" style={{ background: `linear-gradient(135deg, ${COLORS.pink}, #be185d)` }}>
                <i className={id ? "ri-edit-line" : "ri-add-line"}></i>
              </div>
              <div>
                <h5 className="gradient-text">
                  {id ? 'Modifier une naissance' : 'Nouvelle naissance'}
                </h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-baby-line"></i> {id ? 'Modification' : 'Nouveau'}
                  </span>
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i> {new Date().toLocaleDateString('fr-FR')}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <Button size="sm" className="btn-modern-outline" onClick={() => navigate('/evenements/naissances')}>
                <i className="ri-arrow-left-line"></i> Retour
              </Button>
            </div>
          </div>

          {/* ===== NOTIFICATIONS ===== */}
          {error && (
            <div className="toast-notification toast-notification-error mb-4">
              <div className="toast-icon toast-icon-error">
                <i className="ri-error-warning-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                <p className="toast-message">{error}</p>
              </div>
              <button className="toast-close" onClick={() => setError(null)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {success && (
            <div className="toast-notification toast-notification-success mb-4">
              <div className="toast-icon toast-icon-success">
                <i className="ri-checkbox-circle-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                <p className="toast-message">Naissance enregistrée avec succès. Redirection...</p>
              </div>
              <button className="toast-close" onClick={() => setSuccess(false)}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {/* ===== CARD PRINCIPALE ===== */}
          <Row className="justify-content-center">
            <Col lg={8}>
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-information-line"></i>
                  {id ? 'Modifier les informations' : 'Informations de la naissance'}
                </Card.Header>
                <Card.Body className="card-body-modern">

                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group controlId="parent1">
                          <Form.Label className="form-label-modern">
                            Père <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="parent1"
                            value={formData.parent1}
                            onChange={handleInputChange}
                            placeholder="Nom complet du père"
                            isInvalid={!!validationErrors.parent1}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.parent1}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="parent2">
                          <Form.Label className="form-label-modern">
                            Mère <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="parent2"
                            value={formData.parent2}
                            onChange={handleInputChange}
                            placeholder="Nom complet de la mère"
                            isInvalid={!!validationErrors.parent2}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.parent2}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="date_nais">
                          <Form.Label className="form-label-modern">
                            Date naissance <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="date_nais"
                            value={formData.date_nais}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.date_nais}
                            className="form-control-modern"
                          />
                          <Form.Control.Feedback type="invalid">{validationErrors.date_nais}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="lieu">
                          <Form.Label className="form-label-modern">Lieu</Form.Label>
                          <Form.Control
                            type="text"
                            name="lieu"
                            value={formData.lieu}
                            onChange={handleInputChange}
                            placeholder="Lieu de naissance"
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="genre">
                          <Form.Label className="form-label-modern">
                            Genre <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="genre"
                            value={formData.genre}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.genre}
                            className="form-select-modern"
                          >
                            <option value="Garçon">Garçon</option>
                            <option value="Fille">Fille</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">{validationErrors.genre}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="matri_eglise">
                          <Form.Label className="form-label-modern">
                            Église <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="matri_eglise"
                            value={formData.matri_eglise}
                            onChange={handleInputChange}
                            isInvalid={!!validationErrors.matri_eglise}
                            className="form-select-modern"
                          >
                            <option value="">Sélectionnez une église</option>
                            {eglises.map(eglise => (
                              <option key={eglise.matricule} value={eglise.matricule}>
                                {eglise.nom}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">{validationErrors.matri_eglise}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    <div className="d-flex gap-2 justify-content-end mt-4 pt-3 border-top">
                      <Button
                        variant="light"
                        size="sm"
                        className="btn-modern-outline"
                        onClick={() => navigate('/evenements/naissances')}
                        disabled={saving}
                      >
                        Annuler
                      </Button>
                      <Button
                        type="submit"
                        size="sm"
                        className="btn-modern-primary"
                        disabled={saving}
                      >
                        {saving ? (
                          <><Spinner size="sm" className="me-1" /> Enregistrement...</>
                        ) : (
                          <><i className="ri-save-line me-1"></i> {id ? 'Modifier' : 'Enregistrer'}</>
                        )}
                      </Button>
                    </div>
                  </Form>

                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>
    </>
  );
}